import type { Api } from '@/api'
import { Company } from '@/model'
import { defineStore } from 'pinia'
import { computed, inject, ref } from 'vue'
import { useFairStore } from './fair'
import { useSiteStore } from './site'

export const useCompanyStore = defineStore('companyStore', () => {
  const api = inject('exhibitorApi') as Api<unknown>

  const fairStore = useFairStore()
  const siteStore = useSiteStore()
  const isDevelopment = import.meta.env.DEV

  const company = ref<Company>(Company.Empty)

  async function initCompany(): Promise<void> {
    const response = await api.company.infoDetail(fairStore.lastFairId)
    company.value = new Company(response.data)

    if (!isDevelopment) {
      if (fairStore.applicationFormSettings.useUsdCurrencyOnly ?? false) {
        return
      }

      siteStore.changeLocale(company.value.isOverseaCompany ? 'en' : 'ko')
    }
  }

  const fullAddress = computed(() => {
    return getFullAddress(company.value.addr, company.value.addrDetail, company.value.zipCode, company.value.addrEng)
  })

  const getFullAddress = (addr?: string, addrDetail?: string, zipCode?: string, addrEng?: string) => {
    if (common.isKorean()) {
      return `${addr ?? ''} ${addrDetail ?? ''}`
    }

    const addressForEng = [addrEng ?? '', addrDetail ?? '', addr ?? '', company.value.nationDesc ?? '']
    return addressForEng.filter((item) => item).join(', ') + (zipCode ? ` (${zipCode})` : '')
  }

  return { company, initCompany, fullAddress, getFullAddress }
})
